import React from 'react'

import { Badge } from '@/components/ui/badge'

import { Zap } from 'lucide-react'

// Amber badge with a bolt, shown next to coaches (level, "new", ...).
const CoachBadge: React.FC<{
    children: React.ReactNode
    className?: string
}> = ({ children, className }) => (
    <Badge variant="coach" size="xs" className={className}>
        <Zap className="!size-2.5 mr-0.5 fill-current" />
        {children}
    </Badge>
)

export default CoachBadge
